<template lang="jade">
  the-mask.digit(type="text", mask="##:##" v-model="value", :class="{'digit-error': !valid}",
    placeholde="00:00", @focus.native="$event.target.select()", @keyup.prevent="onKeyUp")
</template>

<script>
import { isInputTimeValid } from '../../../utils'

export default {
  props: ['useState', 'kind'],
  computed: {
    valid () {
      return isInputTimeValid(this.value)
    },
    value: {
      get () { return this.$store.getters[this.useState].value },
      set (newVal) { this.$store.dispatch(this.useState, {kind: this.kind, value: newVal}) }
    }
  },
  methods: {
    onKeyUp (e) {
      if (e.key.toLowerCase() === 'a' && e.shiftKey) {
        this.$emit('doAutoFill')
      }
    }
  }
}
</script>

<style scoped>
.digit {
  width: inherit;
  outline: none;
  text-align: center;
  border: none;
  border-bottom: 3px solid rgb(200, 200, 200);
  font-size: 20px;
  background-color: transparent;
}
.digit:focus {
  box-shadow: none !important;
}

.digit-error {
  border-bottom: 3px solid rgb(200, 40, 40) !important;
}
</style>



// WEBPACK FOOTER //
// InputRowGroup.vue?d1238e08